import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.push.js";
var sha256 = require('js-sha256');
import $ from 'jquery';
import { login } from '@/api/user';
import { isPhone, isEmail } from '@/utils/validate';
export default {
  data: function data() {
    return {
      isActive: false,
      checked: false,
      userName: '',
      password: '',
      countryCode: localStorage.getItem('countryCode') || '+86',
      country: localStorage.getItem('country') || 'china',
      type: 'password'
    };
  },
  mounted: function mounted() {},
  methods: {
    input: function input() {
      if (this.userName.trim() !== '' && this.password.trim() !== '') {
        if (isPhone(this.userName) || isEmail(this.userName)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      } else {
        this.isActive = false;
      }
    },
    focus: function focus(dom) {
      $(dom).css('border-image', '-webkit-linear-gradient(#6EDCF5 0%, #6EDCF5 100%) 0 0 100 0');
    },
    blur: function blur(dom) {
      $(dom).css('border-image', 'none');
    },
    showWord: function showWord(type) {
      console.log(1111);
      if (type === 'password') {
        this.type = 'text';
      } else {
        this.type = 'password';
      }
    },
    loginIn: function loginIn(params) {
      var _this = this;
      this.$router.push({
        path: '/social/club'
      });
      login(params).then(function (res) {
        if (res.code === 0) {
          _this.$router.push({
            path: '/social/club'
          });
        } else {
          _this.$toast(res.message);
        }
      });
    },
    toLogin: function toLogin() {
      if (this.userName.trim() !== '' && this.password.trim() !== '') {
        if (this.checked) {
          var params = {};
          if (isPhone(this.userName)) {
            params.countryCode = this.countryCode;
            params.registerType = '1';
          } else {
            if (isEmail(this.userName)) {
              params.registerType = '2';
              delete params.countryCode;
            } else {
              this.$toast('用户名格式不正确');
              return;
            }
          }
          params.deviceId = '123456';
          params.userName = this.userName;
          params.password = sha256(this.password);
          this.loginIn(params);
        } else {
          this.$toast('未同意条款');
        }
      } else {
        this.$toast('请输入用户名或密码');
      }
    },
    toVerification: function toVerification() {
      this.$router.push({
        path: '/loginVerification'
      });
    },
    getCountry: function getCountry() {
      this.$router.push({
        path: '/selectCountry'
      });
    },
    forgetPassword: function forgetPassword() {
      this.$router.push({
        path: '/forgetPassword'
      });
    },
    back: function back() {
      this.$router.back();
    },
    toRefister: function toRefister() {
      this.$router.push({
        path: '/register'
      });
    }
  }
};